var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":'ezoic-pub-ad-placeholder-' + _vm.id}},[_c('Adsense',{attrs:{"data-ad-client":"ca-pub-0703638893464633","data-ad-slot":"9501178283","data-ad-format":"fluid"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }